import { render, staticRenderFns } from "./StudentCodes.vue?vue&type=template&id=208734c6&scoped=true"
import script from "./StudentCodes.vue?vue&type=script&lang=ts"
export * from "./StudentCodes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../planbook-web-ui/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208734c6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../planbook-web-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VChip,VCombobox,VForm,VIcon,VSpacer,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/Users/adrian/planbook/planbook-web-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208734c6')) {
      api.createRecord('208734c6', component.options)
    } else {
      api.reload('208734c6', component.options)
    }
    module.hot.accept("./StudentCodes.vue?vue&type=template&id=208734c6&scoped=true", function () {
      api.rerender('208734c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/auth/StudentCodes.vue"
export default component.exports